import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import "./accountlayout.css";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

function AccountLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1020;
      setIsMobile(mobile);

      // if screen becomes big, leave menu page
      if (!mobile && location.pathname.includes("/account/menu")) {
        navigate(-1, { replace: true });
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [location.pathname, navigate]);

  const isOrdersActive = location.pathname.startsWith("/account/orders");
  const isAddressesActive = location.pathname.startsWith("/account/addresses");
  const isWishlistActive = location.pathname.startsWith("/account/wishlist");

  return (
    <div>
      <Header />

      <div className="account-layout">
        {/* Back button → ONLY mobile */}
        {isMobile && (
          <button
            className="mobile-back-btn"
            onClick={() => navigate("/account/menu")}
          >
            Back
          </button>
        )}

        {/* Sidebar → always desktop */}
        {!isMobile && (
          <div className="sidebar">
            <div className="account-title">
              <p>Account</p>
              <p>{localStorage.getItem("name")}</p>
            </div>
            <div
              className={isOrdersActive ? "active" : ""}
              onClick={() => navigate("/account/orders")}
            >
              <Link to="/account/orders" onClick={(e) => e.stopPropagation()}>
                Orders
              </Link>
            </div>
            <div
              className={isAddressesActive ? "active" : ""}
              onClick={() => navigate("/account/addresses")}
            >
              <Link to="/account/addresses" onClick={(e) => e.stopPropagation()}>
                Address
              </Link>
            </div>
            <div
              className={isWishlistActive ? "active" : ""}
              onClick={() => navigate("/account/wishlist")}
            >
              <Link to="/account/wishlist" onClick={(e) => e.stopPropagation()}>
                Wishlist
              </Link>
            </div>
            <div onClick={() => navigate("/logout")}>
              <Link to="/logout" onClick={(e) => e.stopPropagation()}>
                Logout
              </Link>
            </div>
          </div>
        )}

        {/* Content */}
        <div className="account-outlet">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AccountLayout;
